import {IFreeItemsInPromo, MyListDto, PromosState} from "../../dtos/flyer";
import {Dispatch} from "redux";
import {ActionType} from "../actionTypes/actionTypes";
import {Actions} from "../actions/myListActions";


export const changeMyListItemsAction = (items: PromosState[] | []) => {
    return async (dispatch: Dispatch<Actions>) => {
        dispatch({
            type: ActionType.CHANGE_MY_LIST_ITEMS,
            payload: items ? items : []
        })
    };

}
export const changeMyListBenefitItemsAction = (benefitItems: IFreeItemsInPromo[] | []) => {
    return async (dispatch: Dispatch<Actions>) => {
        dispatch({
            type: ActionType.CHANGE_MY_LIST_BENEFIT_ITEMS,
            payload: benefitItems ? benefitItems : []
        })
    };

}
export const changeMyListItemsAndBenefitItemsAction = (data: MyListDto | null) => {
    console.log("update global state");
    return async (dispatch: Dispatch<Actions>) => {
        dispatch({
            type: ActionType.CHANGE_MY_LIST_ITEMS_AND_BENEFIT_ITEMS,
            payload: data ? data : null
        })
    };

}
